import React, { memo } from 'react';
import { Button, ButtonFill, ButtonWidth, ComponentColor } from '@tcc/fds';
import classNames from 'classnames';
import { useWizard } from 'react-use-wizard';
import { getMessage } from 'util/locale';
import { Step } from './types';

type WizardHeaderProps = {
  steps?: Step[];
  wizardTitle?: string;
  testId: string;
  onClose: () => void;
};

export const WizardHeader = memo(
  function WizardHeader({
    steps,
    wizardTitle = '',
    testId,
    onClose,
  }: WizardHeaderProps) {
    const { activeStep } = useWizard();
    const baseString = 'wizard-header';
    const classString = classNames(`${baseString}`);

    return (
      <header className={`${classString}`} data-test-id={`${testId}-header`}>
        {wizardTitle && (
          <div className={`${classString}-title`} data-test-id={`${testId}-title`}>
            <h1>{wizardTitle}</h1>
          </div>
        )}
        <div className={`${classString}-step-info`}>
          <div className={`${classString}-step-title`} data-test-id={`${testId}-step-title`}>
            {steps[activeStep].title}
          </div>
          <div>
            <Button
              type="button"
              fill={ButtonFill.Outline}
              color={ComponentColor.Neutral}
              width={ButtonWidth.FitContent}
              testId={`${testId}-close-button`}
              onClick={onClose}
            >
              {getMessage('button-text__close')}
            </Button>
          </div>
        </div>
      </header>
    );
  },
  (prevProps, nextProps) => prevProps !== nextProps
);
